import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const PromoBanner = () => {
  const location = useLocation();
  // Set to true to enable Mother's Day promotion, false to hide it
  const mothersDayActive = false;

  const expiryDate = new Date('2026-05-12T00:00:00');
  const now = new Date();

  if (!mothersDayActive || now >= expiryDate || location.pathname === '/mothers-day') return null;

  return (
    <Link to="/mothers-day" className="promo-banner" data-testid="promo-banner">
      <span className="promo-banner-text">
        Mother's Day Offering: $150 in spa credit for $120 - <span className="promo-banner-cta">Explore</span>
      </span>
    </Link>
  );
};

export default PromoBanner;
